import React from 'react';
import { AppLayoutProps } from 'pages/type';

import { makeStyles, Theme } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Link, useLocation } from '@reach/router';
import clsx from 'clsx';
import { path } from 'commons/router/routerConfig';

const useStyles = makeStyles((theme: Theme) => ({
  searchButtonContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    height: '75px',
    [theme.breakpoints.down('md')]: {
      height: '35px',
    },
  },
  isActiveMenu: {
    color: '#000000 !important',
    backgroundColor: 'rgba(255, 255, 255, 1.0) !important',
  },
  searchTypeButton: {
    flexGrow: 1,
    flexBasis: 0,
    borderRadius: 0,
    fontSize: '20px',
    fontWeight: 'bold',
    color: '#ffffff',
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    '&:not(:last-child)': {
      marginRight: '1px',
    },
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    [theme.breakpoints.down('md')]: {
      fontSize: '16px',
      fontWeight: 'bold',
    },
  },
}));

function ContentsLayout({ children }: AppLayoutProps) {
  const classes = useStyles();

  const { pathname } = useLocation();

  return (
    <>
      <nav className={classes.searchButtonContainer}>
        <Button
          component={Link}
          to={path.SEARCH_BY_DATE}
          className={clsx(
            classes.searchTypeButton,
            pathname === path.SEARCH_BY_DATE && classes.isActiveMenu,
          )}
          disabled={pathname === path.SEARCH_BY_DATE}
        >
          경기별 검색
        </Button>
        <Button
          component={Link}
          to={path.SEARCH_BY_RECORD}
          className={clsx(
            classes.searchTypeButton,
            pathname === path.SEARCH_BY_RECORD && classes.isActiveMenu,
          )}
          disabled={pathname === path.SEARCH_BY_RECORD}
        >
          기록별 검색
        </Button>
        <Button
          component={Link}
          to={path.SEARCH_BY_SPECIAL}
          className={clsx(
            classes.searchTypeButton,
            pathname === path.SEARCH_BY_SPECIAL && classes.isActiveMenu,
          )}
          disabled={pathname === path.SEARCH_BY_SPECIAL}
        >
          스페셜 영상
        </Button>
      </nav>
      {children}
    </>
  );
}

export default ContentsLayout;
